import PropTypes from "prop-types";
import { useCallback } from "react";

import { apiClient } from "@/features/shared";
import { CustomAsyncAutocomplete } from "@/features/ui";

export const SupplierSelect = ({
  withSupplierTaxInformation = false,
  withPaymentTerm = false,
  ...props
}) => {
  const fetchSuppliers = useCallback(
    async (searchValue, { page, size } = {}) => {
      const {
        data: { data },
      } = await apiClient.get("suppliers", {
        params: {
          page,
          size,
          search: searchValue,
          withSupplierTaxInformation,
          withPaymentTerm,
        },
      });
      return data;
    },
    [withPaymentTerm, withSupplierTaxInformation]
  );

  return (
    <CustomAsyncAutocomplete
      fetchOptions={fetchSuppliers}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      renderOption={(props, option) => {
        const { id, name, code } = option;

        return (
          <li {...props} key={id}>
            <div>
              <div>
                {name} ({code})
              </div>
            </div>
          </li>
        );
      }}
      {...props}
      TextFieldProps={{
        ...props?.TextFieldProps,
        InputProps: {
          ...(props.TextFieldProps?.InputProps || {}),
          placeholder:
            props.TextFieldProps?.InputProps?.placeholder || "Cari nama/kode",
        },
      }}
    />
  );
};

SupplierSelect.propTypes = {
  withSupplierTaxInformation: PropTypes.bool,
  withPaymentTerm: PropTypes.bool,
  TextFieldProps: PropTypes.object,
};
